// Footer.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from "../public/AfricFreshLogo-01.svg"

function Footer() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const footerElement = document.getElementById('footer');
    if (footerElement) {
      observer.observe(footerElement);
    }

    return () => {
      if (footerElement) {
        observer.unobserve(footerElement);
      }
    };
  }, []);

  const footerSections = [
    {
      title: "Useful Link",
      links: [
        { text: "Home", href: "#" },
        { text: "Food Subscription", href: "#" },
        { text: "Blog", href: "#" },
        { text: "About Us", href: "#" },
        { text: "Contact-US", href: "#" },
        { text: "Privacy Policy", href: "#" },
        { text: "Terms of Service", href: "#" }
      ]
    },
    {
      title: "Product categories",
      links: [
        { text: "GRAINS", href: "#" },
        { text: "FLOUR", href: "#" },
        { text: "OIL", href: "#" },
        { text: "SPICES/SEASONING", href: "#" },
        { text: "PASTE", href: "#" },
        { text: "BEAUTY", href: "#" },
        { text: "BEVERAGES/SNACKS", href: "#" },
        { text: "CANNED FOOD", href: "#" },
        { text: "SEA FOODS", href: "#" }
      ]
    },
    {
      title: "Contact-Us",
      links: [
        { text: "Contact : 346-209-6452", href: "#" },
        { text: "E-mail : Me@africfresh.com", href: "#" },
        { text: "Me@africfresh.comm", href: "#" }
      ]
    },
    {
      title: "Socials",
      links: [
        { text: "Facebook", href: "#" },
        { text: "Instagram", href: "#" },
        { text: "TikTok", href: "#" },
        { text: "Twitter", href: "#" },
        { text: "LinkedIn", href: "#" }
      ]
    }
  ];

  return (
    <footer id="footer">
      <div className="h-full text-[#007D44] bg-[#F2E7DB] flex flex-col justify-between px-5 pt-5 relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute inset-0 opacity-5">
          <div className="animate-float-slow absolute top-10 left-10 w-20 h-20 bg-[#007D44] rounded-full"></div>
          <div className="animate-float-slower absolute top-32 right-20 w-16 h-16 bg-[#007D44] rounded-full"></div>
          <div className="animate-float-slowest absolute bottom-20 left-1/3 w-12 h-12 bg-[#007D44] rounded-full"></div>
        </div>

        <div className='flex max-sm:flex-col relative z-10'>
          <div className="py-2 my-2 w-full">
            <div className="mx-auto px-4 w-full">
              <div className='flex justify-center w-full max-sm:flex-col'>
                <div className={`w-1/2 max-sm:w-full transition-all duration-1000 ${isVisible ? 'animate-slide-in-left' : 'opacity-0 transform translate-x-[-50px]'}`}>
                  <img 
                    src={logo} 
                    alt="Logo" 
                    className="h-[110px] w-[370px] max-sm:w-52 max-sm:h-20 hover:scale-105 transition-transform duration-500 animate-pulse-gentle" 
                  />
                  <p className={`pr-7 max-sm:pr-0 transition-all duration-1000 delay-300 ${isVisible ? 'animate-fade-in-up' : 'opacity-0 transform translate-y-[30px]'}`}>
                    Discover authentic African flavors at your doorstep with AfricFresh - your premier destination for premium African groceries in Texas. We bring the vibrant tastes of Africa to your kitchen, offering carefully sourced ingredients from yam flour to egusi seeds, palm oil to suya spices.
                  </p>
                </div>

                <div className="grid sm:grid-cols-1 md:grid-cols-4 gap-14 max-sm:gap-10 w-4/5 max-sm:w-full">
                  {footerSections.map((section, sectionIndex) => (
                    <div 
                      key={sectionIndex}
                      className={`transition-all duration-1000 ${isVisible ? 'animate-slide-in-up' : 'opacity-0 transform translate-y-[30px]'}`}
                      style={{ animationDelay: `${(sectionIndex + 1) * 200}ms` }}
                    >
                      <h2 className="font-semibold mb-4 max-sm:mt-6 max-sm:mb-1 text-left relative group">
                        {section.title}
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#007D44] transition-all duration-500 group-hover:w-full"></span>
                      </h2>
                      <ul className='text-left'>
                        {section.links.map((link, linkIndex) => (
                          <li 
                            key={linkIndex} 
                            className={`mb-2 transition-all duration-700 ${isVisible ? 'animate-fade-in-stagger' : 'opacity-0'}`}
                            style={{ animationDelay: `${(sectionIndex + 1) * 200 + linkIndex * 100}ms` }}
                          >
                            <a 
                              href={link.href} 
                              className="hover:underline hover:text-[#007D44]/80 transition-all duration-300 hover:translate-x-2 inline-block relative group"
                            >
                              <span className="relative z-10">{link.text}</span>
                              <span className="absolute inset-0 bg-[#007D44]/10 scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100 rounded"></span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              <div className={`flex items-center mt-7 justify-center border-t-2 border-[#3F4231] transition-all duration-1000 ${isVisible ? 'animate-slide-in-bottom' : 'opacity-0 transform translate-y-[20px]'}`}>
                <div className="flex items-center">
                  <p className='mt-3 relative'>
                    &copy; 2025 
                    <span className='font-bold ml-1 hover:text-[#007D44]/80 transition-colors duration-300 cursor-default animate-text-shimmer'>
                      AFRICFRESH
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes slideInBottom {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInStagger {
            from {
              opacity: 0;
              transform: translateX(-20px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes floatSlow {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            50% {
              transform: translateY(-20px) rotate(180deg);
            }
          }

          @keyframes floatSlower {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            50% {
              transform: translateY(-15px) rotate(-180deg);
            }
          }

          @keyframes floatSlowest {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            50% {
              transform: translateY(-10px) rotate(360deg);
            }
          }

          @keyframes pulseGentle {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.02);
              opacity: 0.9;
            }
          }

          @keyframes textShimmer {
            0% {
              background-position: -200% center;
            }
            100% {
              background-position: 200% center;
            }
          }

          .animate-slide-in-left {
            animation: slideInLeft 1s ease-out forwards;
          }

          .animate-slide-in-up {
            animation: slideInUp 1s ease-out forwards;
          }

          .animate-slide-in-bottom {
            animation: slideInBottom 1s ease-out forwards;
          }

          .animate-fade-in-up {
            animation: fadeInUp 1s ease-out forwards;
          }

          .animate-fade-in-stagger {
            animation: fadeInStagger 0.8s ease-out forwards;
          }

          .animate-float-slow {
            animation: floatSlow 8s ease-in-out infinite;
          }

          .animate-float-slower {
            animation: floatSlower 10s ease-in-out infinite;
          }

          .animate-float-slowest {
            animation: floatSlowest 12s ease-in-out infinite;
          }

          .animate-pulse-gentle {
            animation: pulseGentle 3s ease-in-out infinite;
          }

          .animate-text-shimmer {
            background: linear-gradient(90deg, #007D44, #34a536, #007D44);
            background-size: 200% auto;
            color: transparent;
            -webkit-background-clip: text;
            background-clip: text;
            animation: textShimmer 3s linear infinite;
          }

          .hover\:scale-105:hover {
            transform: scale(1.05);
          }

          .hover\:translate-x-2:hover {
            transform: translateX(0.5rem);
          }

          /* Smooth scrolling reveal effect */
          footer {
            opacity: 0;
            animation: fadeInUp 1s ease-out 0.5s forwards;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    </footer>
  );
}

export default Footer;